module.exports = __webpack_public_path__ + "assets/images/stationaryRides-4da8d95feb27a3e7bc659be513a17da5.png";